import { useMutation } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import type { SetupPasswordRequest } from '../types/admin-user.types';

/**
 * React Query hook to setup password for new admin user
 * No cache invalidation needed (public endpoint)
 */
export const useSetupPassword = () => {
  return useMutation({
    mutationFn: (data: SetupPasswordRequest) => adminUsersApi.setupPassword(data),
  });
};
